import { useState } from 'react';

import { cn } from '@/components/ui/cn';
import { isDesktopApp } from './desktop-updates';
import { getDesktopNotifyEnabled, setDesktopNotifyEnabled } from './desktop-notifications';

/** Settings card for the desktop app's native notifications (replaces the WebView-incompatible web-push
 *  control). Renders nothing in a browser. */
export default function DesktopNotifyPanel() {
  const [on, setOn] = useState(getDesktopNotifyEnabled);
  if (!isDesktopApp()) return null;
  const toggle = (v: boolean) => {
    setOn(v);
    setDesktopNotifyEnabled(v);
    if (v) {
      // Immediate confirmation it works: macOS shows the OS permission prompt on first grant, then the
      // toast; Windows (which doesn't prompt — toasts are on by default) shows the toast straight away.
      (window as { __sparkDesktop?: { notify?: (n: { title: string; body: string; url: string }) => void } }).__sparkDesktop?.notify?.({
        title: 'Notifications on',
        body: 'You’ll be notified about @mentions and activity on items you own or watch.',
        url: '',
      });
    }
  };
  return (
    <section className="mb-6 rounded-2xl border border-line bg-surface-raised p-5">
      <div className="flex items-center justify-between gap-4">
        <div>
          <div className="text-[14px] font-semibold text-fg-strong">Desktop notifications</div>
          <p className="mt-0.5 text-[12.5px] text-fg-faint">
            Native notifications for @mentions and activity on items you own, are assigned, or watch — even when
            the window is closed to the tray. macOS asks permission the first time; Windows doesn’t prompt
            (toasts are on by default — manage them in Windows notification settings).
          </p>
        </div>
        <button
          type="button"
          role="switch"
          aria-checked={on}
          aria-label="Desktop notifications"
          onClick={() => toggle(!on)}
          className={cn('relative h-6 w-11 shrink-0 rounded-full transition-colors', on ? 'bg-accent' : 'bg-layer-strong')}
        >
          <span className={cn('absolute top-0.5 h-5 w-5 rounded-full bg-white shadow transition-transform', on ? 'left-[22px]' : 'left-0.5')} />
        </button>
      </div>
    </section>
  );
}
